import { Check, Circle, LoaderCircle } from "lucide-react";

// A process's stages in order (BRK-S369, from Submit's progress screen,
// BRK-S353): the one under way marked `aria-current="step"` with a spinner
// that stops under reduced motion, the ones done ticked, the ones to come
// dimmed. A status announces the stage under way. Submit's progress screen
// and a carrier's quote both show it.

export function ProgressStages({
  stages,
  at,
}: {
  stages: readonly string[];
  /** The stage under way, by index into `stages`. */
  at: number;
}) {
  const current = Math.min(at, stages.length - 1);
  return (
    <>
      <ol className="flex flex-col gap-3">
        {stages.map((name, i) => (
          <li
            key={name}
            aria-current={i === current ? "step" : undefined}
            className={`flex items-center gap-2 text-body ${
              i === current
                ? "font-medium text-brk-text"
                : i < current
                  ? "text-brk-text"
                  : "text-brk-dim"
            }`}
          >
            {i < current ? (
              <Check
                aria-hidden="true"
                className="h-4 w-4 shrink-0 text-green-700 dark:text-green-300"
              />
            ) : i === current ? (
              <LoaderCircle
                aria-hidden="true"
                className="h-4 w-4 shrink-0 text-brk-accent motion-safe:animate-spin"
              />
            ) : (
              <Circle
                aria-hidden="true"
                className="h-4 w-4 shrink-0 text-brk-border"
              />
            )}
            {name}
          </li>
        ))}
      </ol>
      <p role="status" className="sr-only">
        {stages[current]}
      </p>
    </>
  );
}
